import { Socket, SocketOptions, ManagerOptions } from 'socket.io-client';
import ioClient from 'socket.io-client';
import config from "~/config";
import { buildUrl } from './utilHelper';

export const openSocket = (
  namespace?: string | null,
  options?: Partial<SocketOptions & ManagerOptions>
): Socket => {
  if (!namespace) {
    namespace = (config as any).SOCKET_NAMESPACE;
  }
  const url = buildUrl((config as any).API_URL, namespace);
  return ioClient(url, {
    transports: ['websocket'],
    secure: true,
    path: (config as any).SOCKET_PATH,
    ...options,
  });
}

export const closeSocket = (client: Socket | null | undefined) => {
  if (!client) {
    return;
  }
  client.removeAllListeners();
  client.close();
}